import React, { memo, Component } from 'react'

import MuiTypography from '@material-ui/core/Typography'

import CsgCentralizedTemplate from 'components/templates/Centralized'

const Fallback = memo(() => (
  <CsgCentralizedTemplate>
    <MuiTypography variant="h2" gutterBottom>
      Something went wrong
    </MuiTypography>
  </CsgCentralizedTemplate>
))

class ErrorBoundary extends Component {
  state = {
    error: null,
    hasError: false
  }

  static getDerivedStateFromError(error) {
    return {
      error,
      hasError: true
    }
  }

  render() {
    return this.state.hasError ? <Fallback /> : this.props.children
  }
}

export default ErrorBoundary
